import a555 from "../assets/soundbar/hw-a555.png";
import q600b from "../assets/soundbar/hw-q600b.png";
import q800b from "../assets/soundbar/hw-q800b.png";
import q930b from "../assets/soundbar/hw-q930b.png";
import q990b from "../assets/soundbar/hw-q990b.png";
import s800b from "../assets/soundbar/hw-s800b.png";

import blue from "../assets/soundbar/icons/blue.png";
import canais from "../assets/soundbar/icons/canais.png";
import dolby from "../assets/soundbar/icons/dolby.png";
import dts from "../assets/soundbar/icons/dts.png";
import equalizacaoAuto from "../assets/soundbar/icons/equalizacao_auto.png";
import sincronia from "../assets/soundbar/icons/sincronia.png";
import slim from "../assets/soundbar/icons/slim.png";
import somSorround from "../assets/soundbar/icons/som_sorround.png";
import spacefit from "../assets/soundbar/icons/spacefit.png";
import subwoofer from "../assets/soundbar/icons/subwoofer.png";

const soundbarContent = {
    'QN900': {
        'tvModel': 'QN900',
        'soundbarModel': 'HW-Q990B',
        'image': q990b,
        'resource': [
            {
                'icon': dolby,
                'title': 'Wireless Dolby Atmos'
            },
            {
                'icon': canais,
                'title': '11.1.4 canais'
            },
            {
                'icon': sincronia,
                'title': 'Sincronia Sonora'
            },
            {
                'icon': spacefit,
                'title': 'SpaceFit Sound+'
            }
        ]
    },
    'QN800': {
        'tvModel': 'QN800',
        'soundbarModel': 'HW-Q990B',
        'image': q990b,
        'resource': [
            {
                'icon': dolby,
                'title': 'Wireless Dolby Atmos'
            },
            {
                'icon': canais,
                'title': '11.1.4 canais'
            },
            {
                'icon': sincronia,
                'title': 'Sincronia Sonora'
            },
            {
                'icon': spacefit,
                'title': 'SpaceFit Sound+'
            }
        ]
    },
    'QN90': {
        'tvModel': 'QN90',
        'soundbarModel': 'HW-Q600B',
        'image': q600b,
        'resource': [
            {
                'icon': dolby,
                'title': 'Dolby Atmos + DTS:X'
            },
            {
                'icon': canais,
                'title': '3.1.2 canais'
            },
            {
                'icon': sincronia,
                'title': 'Sincronia Sonora'
            },
            {
                'icon': equalizacaoAuto,
                'title': 'Equalização automática'
            }
        ]
    },
    'QN85': {
        'tvModel': 'QN85',
        'soundbarModel': 'HW-Q930B',
        'image': q930b,
        'resource': [
            {
                'icon': dolby,
                'title': 'Wireless Dolby Atmos'
            },
            {
                'icon': canais,
                'title': '9.1.4 canais'
            },
            {
                'icon': sincronia,
                'title': 'Sincronia Sonora'
            },
            {
                'icon': spacefit,
                'title': 'SpaceFit Sound'
            }
        ]
    },
    'Q80': {
        'tvModel': 'Q80',
        'soundbarModel': 'HW-Q800B',
        'image': q800b,
        'resource': [
            {
                'icon': dolby,
                'title': 'Wireless Dolby Atmos'
            },
            {
                'icon': canais,
                'title': '5.1.2 canais'
            },
            {
                'icon': sincronia,
                'title': 'Sincronia Sonora'
            },
            {
                'icon': spacefit,
                'title': 'SpaceFit Sound'
            }
        ]
    },
    'Q70': {
        'tvModel': 'Q70',
        'soundbarModel': 'HW-Q600B',
        'image': q600b,
        'resource': [
            {
                'icon': dolby,
                'title': 'Dolby Atmos + DTS:X'
            },
            {
                'icon': canais,
                'title': '3.1.2 canais'
            },
            {
                'icon': sincronia,
                'title': 'Sincronia Sonora'
            },
            {
                'icon': equalizacaoAuto,
                'title': 'Equalização automática'
            }
        ]
    },
    'Q60': {
        'tvModel': 'Q60',
        'soundbarModel': 'HW-Q600B',
        'image': q600b,
        'resource': [
            {
                'icon': dolby,
                'title': 'Dolby Atmos + DTS:X'
            },
            {
                'icon': canais,
                'title': '3.1.2 canais'
            },
            {
                'icon': sincronia,
                'title': 'Sincronia Sonora'
            },
            {
                'icon': equalizacaoAuto,
                'title': 'Equalização automática'
            }
        ]
    },
    'BU8000': {
        'tvModel': 'BU8000',
        'soundbarModel': 'HW-A555',
        'image': a555,
        'resource': [
            {
                'icon': dts,
                'title': 'DTS Virtual'
            },
            {
                'icon': somSorround,
                'title': 'Som Surround'
            },
            {
                'icon': blue,
                'title': 'Conexão Bluetooth'
            },
            {
                'icon': subwoofer,
                'title': 'Subwoofer Wireless'
            }
        ]
    },
    'The Frame': {
        'tvModel': 'theFrame',
        'soundbarModel': 'HW-S800B',
        'image': s800b,
        'resource': [
            {
                'icon': slim,
                'title': 'Ultra Slim Design'
            },
            {
                'icon': dolby,
                'title': 'Wireless Dolby Atmos'
            },
            {
                'icon': canais,
                'title': '3.1.2 canais'
            },
            {
                'icon': sincronia,
                'title': 'Sincronia Sonora'
            }
        ]
    },
    'The Serif': {
        'tvModel': 'theSerif',
        'soundbarModel': 'HW-S800B',
        'image': s800b,
        'resource': [
            {
                'icon': slim,
                'title': 'Ultra Slim Design'
            },
            {
                'icon': dolby,
                'title': 'Wireless Dolby Atmos'
            },
            {
                'icon': canais,
                'title': '3.1.2 canais'
            },
            {
                'icon': sincronia,
                'title': 'Sincronia Sonora'
            }
        ]
    },
    'The Sero': {
        'tvModel': 'theSero',
        'soundbarModel': 'HW-S800B',
        'image': s800b,
        'resource': [
            {
                'icon': slim,
                'title': 'Ultra Slim Design'
            },
            {
                'icon': dolby,
                'title': 'Wireless Dolby Atmos'
            },
            {
                'icon': canais,
                'title': '3.1.2 canais'
            },
            {
                'icon': sincronia,
                'title': 'Sincronia Sonora'
            }
        ]
    },
    'The Freestyle': {
        'tvModel': 'theFreestyle',
        'soundbarModel': 'HW-S800B',
        'image': s800b,
        'resource': [
            {
                'icon': slim,
                'title': 'Ultra Slim Design'
            },
            {
                'icon': dolby,
                'title': 'Wireless Dolby Atmos'
            },
            {
                'icon': canais,
                'title': '3.1.2 canais'
            },
            {
                'icon': sincronia,
                'title': 'Sincronia Sonora'
            }
        ]
    },
}

export default soundbarContent;